// extracted by mini-css-extract-plugin
export var content = "ExpandableListPostsModule-module--content--m9uzx";
export var item = "ExpandableListPostsModule-module--item--GYsKf";
export var summary = "ExpandableListPostsModule-module--summary--HeFm7";